import React from "react"
import * as styles from "./dashboard-documents.module.scss"
import { ErrorBoundary } from "../../components/ErrorBoundary"
import { DocumentsRecap } from "../../components/DocumentsRecap/DocumentsRecap"

export const DashboardDocuments: React.FunctionComponent = () => {
  return (
    <ErrorBoundary>
      <main className={styles.dashboard}>
        <h1 className="u-visually-hidden">Documenti aggiuntivi</h1>
        <div className={styles.recap}>
          <DocumentsRecap />
        </div>
      </main>
    </ErrorBoundary>
  )
}

export default DashboardDocuments
